<div style="display: flex; flex-direction: row; justify-content: space-between">
  <div>
    <h2>Test Runs</h2>

    <button
      class="iconButton"
      (click)="runTests()"
      [showLoadingSpinner]="loading"
    >
      Run Tests
    </button>

    <table>
      <thead>
        <th>Started</th>
        <th>Finished</th>
        <th>Success %</th>
        <th>Total Tests</th>
        <th>Passed Tests</th>
        <th>Elapsed Time</th>
      </thead>
      @for (
        item of this.testRuns;
        track item;
        let even = $even;
        let odd = $odd
      ) {
        <tr (click)="getTests(item.id)" style="cursor: pointer">
          <td>{{ formatTime(item.createdOn.toString()) }}</td>
          <td>{{ formatTime(item.finishedOn.toString()) }}</td>
          <td [style]="getTestRunBackgroundColor(item.successPct)">
            {{ item.successPct }}%
          </td>
          <td>{{ item.totalTests }}</td>
          <td>{{ item.successTests }}</td>
          <td>{{ formatElapsedTime(item.totalTime) }}</td>
        </tr>
      }
    </table>
  </div>
</div>

<div [hidden]="tests.length == 0">
  <h2>Tests</h2>

  <table>
    <thead>
      <th>Test</th>
      <th>Result</th>
      <th>Error</th>
      <th>Duration</th>
    </thead>
    @for (item of this.tests; track item; let even = $even; let odd = $odd) {
      <tr>
        <td>{{ item.name }}</td>
        <td [style]="getTestBackgroundColor(item.success)">
          {{ item.success ? 'Passed' : 'Failed' }}
        </td>
        <td>{{ item.error }}</td>
        <td>{{ formatElapsedTime(item.duration) }}</td>
      </tr>
    }
  </table>
</div>
